import React, { Fragment } from 'react';
import _ from 'lodash';
import { useQuery } from '@apollo/react-hooks';
import { GET_OWNED_TILES } from '../services/graphql';
import ItemPreview from './ItemPreview';
import Coins from '../../Dashboard/images/gem.svg';

const Tiles = ({ item, onRemoveItem, onSelectTile}) => {
    const { data, error, loading } = useQuery(GET_OWNED_TILES, {
        variables: {
            avatarItemId: item.id
        },
        fetchPolicy: 'network-only'
    });
    if (loading) {
        return <p>Loading</p>
    }
    if (error) {
        return <p>Something went wrong</p>
    }
    if (data) {
    return (
        <Fragment>
            <li className="store__tile-heading">Choose a style for this {item.type}.</li>
            {
                _.map(item.url, (tile, index) => {
                    const tileNumber = index + 1;
                    const tileOwned = data.tilesForItem.includes(tileNumber);
                    const tileSelected = Number(item.tile) === tileNumber;

                    return (
                        <li key={`tile-${item.id}-${index}`} onClick={() => onSelectTile(tileNumber, tileOwned)} className={`store__item ${tileSelected ? 'store__item--wearing' : ''}`}>
                            <p className="store__item-name">Style {tileNumber}</p>
                            {item.type === 'backdrop' ? <img src={tile} className="store__backdrop-thumbnail" alt="Backdrop" /> : <ItemPreview src={tile} className="store__item-img" />}
                            <span className="store__item-selected" aria-hidden="true">{tileSelected ? '✓' : ''}</span>
                            <p className={`store__item-status ${tileOwned ? 'store__item-status--owned' : ''}`}>
                                {tileOwned ?
                                    <><span aria-hidden="true">✓</span> Owned</> :
                                    <><img src={Coins} alt="Gems" /> {item.price}</>
                                }
                            </p>
                        </li>
                    )
                })
            }
            {
                item.owned && item.wearing ? 
                <li onClick={() => onRemoveItem()} className={`store__item store__item--remove ${Number(item.tile) === -1 ? 'store__item--wearing' : ''}`}>
                    <span className="store__item-img store__item-img--remove">Remove</span>
                </li> :
                null
            }
        </Fragment>
    );
    }
    return null
}

export default Tiles;
